'use client';

import { useQuery } from '@tanstack/react-query';
import { useHttpClient } from '@wix/fe-essentials-standalone';

import { pollRequest } from '@/lib/pollRequest';

const METASITE_APP_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';

export function useWixInstance(
  siteUrl: string,
  options?: { enabled?: boolean },
) {
  const httpClient = useHttpClient();
  const siteCleanUrl = siteUrl.split('?')[0];

  return useQuery<string | null>({
    queryKey: ['wixInstance', siteCleanUrl],
    queryFn: () =>
      pollRequest(
        async () => {
          const { data } = await httpClient.get<{
            apps: { [key: string]: { instance: string } };
          }>(`${siteCleanUrl}/_api/v1/access-tokens`);
          return data?.apps?.[METASITE_APP_ID]?.instance ?? null;
        },
        5,
        500,
      ),
    enabled: (options?.enabled ?? true) && Boolean(siteUrl),
    staleTime: 5 * 60 * 1000,
  });
}
